import hasDesign from "./has-design";

// basic
// basic_variant_dependent
// per_item_quantity_discounts
// variant_and_quantity_dependent
// card_packs

export const getDesignInfo = ({data, meta}) => {
  return meta.reduce(
    (acc, design, i) => {
      if (!design.additional && data[i] && hasDesign(data[i].design)) {
        return {...acc, main: acc.main + 1};
      } else if (design.additional && data[i] && hasDesign(data[i].design)) {
        return {...acc, additional: acc.additional + 1};
      }
      return {...acc};
    },
    {
      main: 0,
      additional: 0
    }
  );
};

export const getFormattedBasicDependentPriceMap = (priceMap) => {
  // {
  //   black: [117000, 23000, 15000]
  //   light-blue: [117000, 23000, 15000]
  //   melange: [117000, 23000, 15000]
  //   turquoise: [117000, 23000, 15000]
  //   white: [89000, 21000, 15000]
  //   yellow: [117000, 23000, 15000]
  // }
  return priceMap.reduce((acc, current, index) => {
    if (!(index % 2)) {
      return {
        ...acc,
        ...Object.values(current).reduce((_, elem) => {
          return elem.reduce((a, el) => {
            return {...a, [el]: Object.values(priceMap[index + 1])};
          }, {});
        }, {})
      };
    } else {
      return {...acc};
    }
  }, {});
};
const getPriceForBasicVariantDependent = (priceData, {variants, designs}) => {
  const priceMap = getFormattedBasicDependentPriceMap(priceData.variant_prices);
  const dependent = Object.keys(priceData.variant_prices[0])[0];
  const priceMapForVariant = priceMap[variants[dependent]];
  const {main, additional} = getDesignInfo(designs);
  let price = priceMapForVariant[0];
  if (main > 1 && priceMapForVariant[1]) {
    price += priceMapForVariant[1];
  }
  if (additional && priceMapForVariant[2]) {
    price += priceMapForVariant[2] * additional;
  }
  return price;
};

const getPriceForBasic = (priceData, {designs}) => {
  const {main, additional} = getDesignInfo(designs);
  let price = priceData.base_price;
  if (main > 1 && priceData.double_side_adjustment) {
    price += priceData.double_side_adjustment;
  }
  if (additional && priceData.additional_design_adjustment) {
    price += priceData.additional_design_adjustment * additional;
  }
  return price;
};

const getPriceForPerItemQuantityDiscounts = (priceData) => {
  return Object.values(priceData.price_map)[0];
};

export const getFormattedVariantAndQuantityDependent = (priceMap) => {
  // don't take quantity
  // {
  //   milk: 2000
  //   bitter: 2200
  // }

  return priceMap.reduce((acc, item, index) => {
    if (Array.isArray(item)) {
      return item.reduce((ac, el, i) => {
        return {...ac, [el]: Object.values(priceMap[index + 1])[0][i]};
      }, {});
    }
    return acc;
  }, {});
};
const getPriceForVariantAndQuantityDependent = (priceData, {variants}) => {
  const priceMap = getFormattedVariantAndQuantityDependent(priceData.price_map);
  const dependent = priceData.variant_prices[0];
  return priceMap[variants[dependent]];
};

export const getFormattedPaperPriceMap = (priceMap) => {
  // {
  //   black: [117000, 23000]
  //   light-blue: [117000, 23000]
  //   melange: [117000, 23000]
  //   turquoise: [117000, 23000]
  //   white: [89000, 21000]
  //   yellow: [117000, 23000]
  // }
  return priceMap.reduce((acc, arr, index) => {
    if (Array.isArray(arr)) {
      return arr.reduce(
        (ac, prop) => ({...ac, [prop]: priceMap[index + 1][200]}),
        {...acc}
      );
    }
    return acc;
  }, {});
};
const getPriceForCardPacks = (priceData, {variants, designs}) => {
  const paperPriceMap = getFormattedPaperPriceMap(priceData.paper_price_maps);
  const laminationPriceMap = priceData.lamination_per_100;
  const cornerRadiusPriceMap = priceData.rounded_corners_per_100;
  const {main} = getDesignInfo(designs);

  let price = paperPriceMap[variants.paper_type][main > 1 ? 1 : 0];
  if (laminationPriceMap[variants.lamination]) {
    price += laminationPriceMap[variants.lamination];
  }
  if (variants.corner_radius !== `0`) {
    price += cornerRadiusPriceMap;
  }
  return price;
};

export const getPriceFromScheme = (priceData, options) => {
  let price;
  switch (priceData.pricing_scheme) {
    case `basic_variant_dependent`:
      price = getPriceForBasicVariantDependent(priceData, options);
      break;
    case `basic`:
      price = getPriceForBasic(priceData, options);
      break;
    case `per_item_quantity_discounts`:
      price = getPriceForPerItemQuantityDiscounts(priceData);
      break;
    case `variant_and_quantity_dependent`:
      price = getPriceForVariantAndQuantityDependent(priceData, options);
      break;
    case `card_packs`:
      price = getPriceForCardPacks(priceData, options);
  }
  return price;
};
